import { AxiosInstance, AxiosResponse } from 'axios';

export default class ValidationDashboardAPI {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async listReportingPackages(): Promise<AxiosResponse> {
    return this.client.get('/v2/hedge-accounting/reporting-packages/');
  }

  async getValidationResults(packageId: string | number): Promise<AxiosResponse> {
    return this.client.get(
      `/v2/hedge-accounting/reporting-packages/${packageId}/validation-results/`,
    );
  }
}
